import { Card, Heading, Text } from '../../../shared/styles/components/primitives.styles';
import { mixins, rgba, typography } from '../../../shared/styles/core/utils';

import { Button } from '../../../shared/styles/components/forms.styles';
import styled from '@emotion/styled';
import { theme } from '../../../shared/styles/core/theme';
import { tokens } from '../../../shared/styles/core/tokens';

export const FiscalPickerContainer = styled.div`
   display: flex;
   flex-direction: column;
   gap: ${tokens.space.xs};
`;

export const CalendarContainer = styled(Card)`
   padding: ${tokens.space.xl};
   width: fit-content;
   min-width: 480px;
`;

export const YearNavigationContainer = styled.div`
   display: flex;
   align-items: center;
   justify-content: space-between;
   margin: 0 auto;
   width: 180px;
`;

export const YearButton = styled.span<{ disabled?: boolean }>`
   ${mixins.hoverHighlight};
   padding: ${tokens.space.xs} ${tokens.space.md};
   font-weight: ${tokens.font.weight.semibold};
   font-size: ${tokens.font.size.md};
   color: ${theme.colors.border.focus};
   user-select: none;

   ${({ disabled }) =>
      disabled &&
      `
      opacity: 0.5;
      cursor: not-allowed;
      pointer-events: none;
      color: ${theme.colors.text.tertiary};
   `}
`;

export const YearText = styled(Heading)`
   font-size: ${tokens.font.size.md};
   text-align: center;
`;

export const YearDivider = styled.div`
   display: flex;
   align-items: center;
   justify-content: center;
   margin: ${tokens.space.sm} 0;
   gap: 10px;
`;

export const YearLine = styled.div`
   height: 1px;
   background-color: ${theme.colors.bg.tertiary};
   flex-grow: 1;
   max-width: 100px;
`;

export const CalendarYearText = styled(Text)`
   color: ${theme.colors.text.tertiary};
   font-size: ${tokens.font.size.sm};
   text-align: center;
   padding: 0 ${tokens.space.sm};
`;

export const TertialRow = styled.div`
   display: flex;
   align-items: center;
   margin-bottom: ${tokens.space.sm};
`;

export const TertialLabel = styled(Heading)`
   width: 100px;
   font-size: ${tokens.font.size.md};
`;

export const MonthsContainer = styled.div`
   display: flex;
   gap: ${tokens.space.md};
`;

export const MonthButton = styled(Button) <{ isSelected?: boolean }>`
   padding: ${tokens.space.md} ${tokens.space.xs};
   background: ${({ isSelected }) => (isSelected ? theme.colors.border.focus : 'transparent')};
   color: ${({ isSelected }) => (isSelected ? theme.colors.bg.primary : theme.colors.text.primary)};
   font-size: ${tokens.font.size.md};
   font-weight: ${({ isSelected }) => (isSelected ? tokens.font.weight.semibold : tokens.font.weight.normal)};
   min-width: 70px;
   border: ${tokens.border.thin} ${({ isSelected }) => (isSelected ? theme.colors.border.focus : 'transparent')};

   &:hover:not(:disabled) {
      background-color: ${({ isSelected }) => (isSelected ? theme.colors.border.focus : theme.colors.bg.secondary)};
   }
`;

export const FiscalYearPickerContainer = styled.div`
   margin: ${tokens.space.md} 0;
`;

export const HistorySection = styled.div`
   margin-top: ${tokens.space.xl};
   padding-top: ${tokens.space.md};
   border-top: ${tokens.border.thin} ${theme.colors.border.default};
`;

export const HistoryList = styled.ul`
   margin: 0;
   padding-left: ${tokens.space.lg};
   list-style-type: disc;
   max-height: 200px;
   overflow-y: auto;
`;

export const HistoryItem = styled.li`
   font-size: ${tokens.font.size.sm};
   color: ${theme.colors.text.primary};
   margin-bottom: ${tokens.space.xs};
`;

export const InfoText = styled.p`
   margin-top: 0;
   margin-bottom: ${tokens.space.xl};
   ${typography.bodyS};
   color: ${theme.colors.text.primary};
`;

export const CurrentDate = styled.span`
   font-weight: ${tokens.font.weight.semibold};
   color: ${theme.colors.text.primary};
`;

export const ModalHeader = styled.h3`
   margin-top: 0;
   margin-bottom: ${tokens.space.lg};
   font-size: ${tokens.font.size.lg};
   font-weight: ${tokens.font.weight.semibold};
   color: ${theme.colors.text.primary};
`;

export const SectionHeader = styled.h4`
   margin: 0 0 ${tokens.space.sm} 0;
   font-size: ${tokens.font.size.md};
   font-weight: ${tokens.font.weight.semibold};
   color: ${theme.colors.text.primary};
`;

export const ModalBackdrop = styled.div`
   position: fixed;
   top: 0;
   left: 0;
   width: 100%;
   height: 100%;
   background-color: ${rgba(theme.colors.text.primary, 0.5)};
   display: flex;
   justify-content: center;
   align-items: center;
   z-index: ${tokens.zIndex.modal};
`;

export const ModalContent = styled.div`
   ${mixins.card};
   padding: ${tokens.space.xl};
   box-shadow: ${tokens.shadow.lg};
   max-width: 600px;
   width: 100%;
   max-height: 90vh;
   overflow-y: auto;
`;

export const ButtonContainer = styled.div`
   display: flex;
   justify-content: flex-end;
   gap: ${tokens.space.md};
   margin-top: ${tokens.space.xl};
`;

export const ValidationError = styled.div`
   font-size: ${tokens.font.size.sm};
   margin-top: ${tokens.space.xs};
   color: ${theme.colors.state.error};
`;
